import DefaultSelect from '@material-ui/core/Select';
import DefaultMenuItem from '@material-ui/core/MenuItem';
import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { FiChevronDown as DefaultChevronDown, FiCheck } from 'react-icons/fi';

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const ChevronDown = styled(DefaultChevronDown)``;

export const Check = styled(FiCheck)`
  color: transparent;
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 0.6875rem;
`;

const Dropdown = styled(DefaultSelect)`
  &.MuiInputBase-root {
    font-family: inherit;
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.navyGreen};
    border-radius: 1rem;
    display: flex;
    align-items: center;
    padding: 1rem;
    height: 3.5rem;
    font-size: 1.1875rem;
    line-height: 1.6625rem;
    font-weight: 600;
    ${Check} {
      display: none;
    }
  }

  .MuiSelect-select.MuiSelect-select {
    padding: 0 2rem 0 0.5rem;

    &:focus,
    &:active {
      background: inherit;
    }
  }

  &.MuiInput-underline:before,
  &.MuiInput-underline:after {
    content: none;
  }

  .MuiSelect-icon {
    right: 1rem;
    top: 1rem;
    width: 1.5rem;
    height: 1.5rem;
    ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  }

  .MuiSelect-select.Mui-disabled {
    color: ${({ theme }) => theme.colors.gray4};
    cursor: default;
  }

  .MuiPopover-paper {
    background: ${({ theme }) => theme.colors.white};
    box-shadow:
      0rem 0.5rem 1rem rgba(35, 35, 35, 0.02),
      0rem 0.5rem 2rem rgba(35, 35, 35, 0.02);
    height: auto;
    margin-top: 1.5rem;
    border-radius: 1rem;
    padding: 0.625rem 0.75rem;
  }
`;

// TODO: TFR-49 or TFR-45 - it doesn't look like select should have menu inside. Menu component exists. Need to rename or move into Menu component
export const MenuItem = styled(DefaultMenuItem)`
  &.MuiMenuItem-root {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-family: inherit;
    color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
    width: 11.1rem;
    height: 3rem;
    font-size: 1.0625rem;
    line-height: 1.4875rem;
    border-radius: 0.5rem;
    ${Check} {
      display: block;
    }

    &.Mui-selected {
      font-weight: 600;
      color: ${({ theme }) => theme.colors.navyGreen};
      background: transparent;
      width: 100%;

      ${Check} {
        color: ${({ theme }) => theme.colors.navyGreen};
      }

      :hover {
        background: ${({ theme }) => theme.colors.navyGreenLight};
      }
    }

    :not(:first-child) {
      margin-top: 0.625rem;
      width: 100%;
    }
    :first-child {
      width: 100%;
    }

    :hover {
      background: ${({ theme }) => theme.colors.navyGreenLight};
    }
  }
`;

export default Dropdown;
